/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type ServicedeskCmdbAssetsCustomMetrics from '@jira/spa-apps__servicedesk-cmdb-assets-custom-metrics/src/CmdbAssetsAnalyticsDataViewList.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskCmdbAssetsAnalyticsDataViewList: LazyComponent<
	() => React.JSX.Element
> = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof ServicedeskCmdbAssetsCustomMetrics>(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-cmdb-assets-analytics-data-view-list", jiraSpaEntry: "async-servicedesk-assets-analytics-data-view-list" */ '@jira/spa-apps__servicedesk-cmdb-assets-custom-metrics/src/CmdbAssetsAnalyticsDataViewList.tsx'
			).then((exportedMembers) => exportedMembers.CmdbAssetsAnalyticsDataViewList),
		{ ssr: false },
	);

export const LazyServicedeskCmdbAssetsAnalyticsDataViewCreate: LazyComponent<
	() => React.JSX.Element
> = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof ServicedeskCmdbAssetsCustomMetrics>(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-cmdb-assets-analytics-data-view-create", jiraSpaEntry: "async-servicedesk-assets-analytics-data-view-create" */ '@jira/spa-apps__servicedesk-cmdb-assets-custom-metrics/src/CmdbAssetsAnalyticsDataViewList.tsx'
			).then((exportedMembers) => exportedMembers.CmdbAssetsAnalyticsDataViewCreate),
		{ ssr: false },
	);

export const LazyServicedeskCmdbAssetsAnalyticsDataViewDetails: LazyComponent<
	() => React.JSX.Element
> = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof ServicedeskCmdbAssetsCustomMetrics>(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-cmdb-assets-analytics-data-view-details", jiraSpaEntry: "async-servicedesk-assets-analytics-data-view-details" */ '@jira/spa-apps__servicedesk-cmdb-assets-custom-metrics/src/CmdbAssetsAnalyticsDataViewList.tsx'
			).then((exportedMembers) => exportedMembers.CmdbAssetsAnalyticsDataViewDetails),
		{ ssr: false },
	);

export const AssetsAnalyticsDataViewList = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskCmdbAssetsAnalyticsDataViewList}
		pageId="spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-list"
		shouldShowSpinner
	/>
);

export const AssetsAnalyticsDataViewCreate = (): React.JSX.Element => {
	return (
		<LazyPage
			Page={LazyServicedeskCmdbAssetsAnalyticsDataViewCreate}
			pageId="spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-create"
			shouldShowSpinner
		/>
	);
};

export const AssetsAnalyticsDataViewDetails = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskCmdbAssetsAnalyticsDataViewDetails}
		pageId="spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-details"
		shouldShowSpinner
	/>
);
